import * as Yup from 'yup';
import i18n from 'i18n';

export default Yup.object().shape({
  schedule_datetime: Yup.string()
    .nullable()
    .required(i18n.t('REQUIRED_FIELD_KEY')),
  replace_instances: Yup.object().shape({
    instance_block_user_message: Yup.string().when('notify_users', {
      is: true,
      then: Yup.string()
        .required(i18n.t('REQUIRED_FIELD_KEY'))
        .nullable(true),
      otherwise: Yup.string().nullable(true),
    }),
  }),
});
